<template>
  <div class="table mb30">
    <div class="titleBox">
      <p class="boxTitle mb15">{{locale.analytics_pageview_by_page}}</p>
      <button type="button" class="btnDownload" @click="download">DOWNLOAD</button>
    </div>
    <div class="tableWrap" ref="viewTable">
      <table>
        <thead>
          <tr>
            <th v-for="(item, i) in sortList" :key="item.name"
              :class="{center: item.name !== 'title', center: i > 0}">
              <span class="clickable"
                :class="{
                  active: item.active,
                  reverse: item.order
                }"
                @click="sort(item.name)">
                {{getName(item.name)}}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(data, index) in body"
            :key="index">
            <td>
              <span class="lang">{{ getLang(data.path) }}</span>
              {{data.title}}
              <p class="colorGrey path"><a :href="dataPath(data.path)" target="_blank">{{data.path}}</a></p>
            </td>
            <td class="center">{{comma(data.views)}}</td>
            <td class="center">{{comma(data.sessions)}}</td>
            <td class="center">{{data.sessionDur.toFixed(1)}}s</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DOWNLOAD from '@/common/download'
import regExp from '@/common/regExp'

export default {
  name: 'PageView',
  props: [
    'locale',
    'pageView',
    'filter',
    'productInfo'
  ],
  computed: {
    siteid () {
      return this.$store.state.authentication.userInfo === null ? null : this.$store.state.authentication.userInfo.siteid
    },
    body () {
      const productInfo = this.productInfo
      const getTitle = (data) => {
        let result = ''
        if (data.path && data.path.includes('product')) {
          const split = data.path.split('/')
          const id = split[3]
          const category = split[4]
          result = data.title
          // 상품인 경우 상품의 카테고리가 있기 때문에 별도로 붙여줘야함
          result += category
            ? productInfo.find(x => x.id === id) && productInfo.find(x => x.id === id).category && productInfo.find(x => x.id === id).category.find(x => `${x.id}` === category)
              ? ` - ${productInfo.find(x => x.id === id).category.find(x => `${x.id}` === category).text}`
              : ''
            : ''
        } else {
          result = data.title
        }
        return result
      }
      const sortBy = this.sortable.sortBy
      const order = this.sortable.order ? 'asc' : 'des'
      const list = this.pageView.map(function (x) {
        return {
          path: x.path,
          title: productInfo ? getTitle(x) : x.title,
          views: parseInt(x.views),
          sessions: parseInt(x.sessions),
          sessionDur: parseFloat(parseFloat(x.sessionDur).toFixed(1))
        }
      })
      function listSort (arr) {
        return arr.sort(function (a, b) {
          if (order === 'des') {
            return a[sortBy] > b[sortBy] ? -1 : a[sortBy] < b[sortBy] ? 1 : 0
          } else {
            return a[sortBy] < b[sortBy] ? -1 : a[sortBy] > b[sortBy] ? 1 : 0
          }
        })
      }
      return listSort(list)
    }
  },
  data () {
    return {
      sortable: {
        sortBy: 'views',
        order: false // order - true: ascending / false: descending
      },
      sortList: [
        {
          name: 'title',
          title: 'title',
          active: false,
          order: false
        },
        {
          name: 'views',
          title: 'views',
          active: true,
          order: false
        },
        {
          name: 'sessionPerUsers',
          title: 'sessionPerUsers',
          active: false,
          order: false
        },
        {
          name: 'sessionDur',
          title: 'sessionDur',
          active: false,
          order: false
        }
      ]
    }
  },
  methods: {
    comma (str) {
      return regExp.comma(str)
    },
    dataPath (path) {
      const siteid = this.siteid
      const urlPath = path.replace(`${siteid}/`, '#/')
      const href = `/viewer/index.html?site=${siteid}`
      return href + urlPath
    },
    getLang (path) {
      return path && path.split('/')[1]
    },
    getName (name) {
      const result = `analytics_pageview_${name}`
      return this.locale[result]
    },
    sort (sortBy) {
      const table = this.$refs.viewTable
      if (table) {
        table.scrollTo(0, 0)
      }
      this.sortable.order = this.sortable.sortBy === sortBy ? !this.sortList.find(x => x.name === sortBy).order : false
      this.sortable.sortBy = sortBy
      this.sortList.forEach(function (x) {
        if (x.name === sortBy && x.active) {
          x.order = !x.order
        }
        x.active = x.name === sortBy
      })
    },
    download () {
      const filename = `pageview_${this.filter.startDate}_${this.filter.endDate}.csv`
      const list = this.body
      DOWNLOAD.jsonToCsv(filename, list)
    }
  }
}
</script>

<style lang="scss" scoped>
.titleBox {
  position: relative;
}
.clickable {
  display: inline-block;
  position: relative;
  margin-top: 4px;
  cursor: pointer;
  &.active {
    &:before {
      content: "";
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: $color-lgrey2;
    }
    &:after {
      display: block;
    }
  }
  &:after {
    content: "";
    display: none;
    position: absolute;
    bottom: 100%;
    left: 50%;
    width: 6px;
    height: 6px;
    margin-bottom: 4px;
    margin-left: -6px;
    border-left: 1px solid $color-lgrey;
    border-bottom: 1px solid $color-lgrey;
    transform: rotate(-45deg);
  }
  &.reverse:after {
    margin-bottom: 0;
    transform: rotate(135deg);
  }
}
.path {
  width: 560px;
  font-size: 12px;
}
.lang {
  display: inline-block;
  margin-right: 6px;
  padding: 0 0.3em;
  font-size: 10px;
  color: $color-lgrey;
  border: 1px solid $color-lgrey2;
  border-radius: 4px;
  background-color: $color-white;
}
th.link {
  text-align: left;
}
td:not(:nth-of-type(1)) {
  width: 160px;
}
.shortcut img {
  width: 16px;
}
.btnDownload {
  position: absolute;
  bottom: 0;
  right: 0;
  display: inline-block;
  padding-right: 1em;
  font-weight: 600;
  color: #448e47;
  border: 2px solid #448e47;
  background-color: $color-white;
  transition: all 0.3s;
  &:before {
    content: "";
    display: inline-block;
    width: 32px;
    height: 32px;
    margin-right: 1em;
    vertical-align: middle;
    background: #448e47 url('~@/assets/img/ico_csv.svg') 50% 50% / 24px no-repeat;
    transition: all 0.3s;
  }
  &:hover {
    color: $color-white;
    background-color: #448e47;
    &:before {
      margin-left: 0.5em;
      margin-right: 0.5em;
    }
  }
}
</style>
